import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import API from '../../services/api.ts';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';
import styles from './Login.module.css';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      await API.post('/accounts/password-reset/', { email });
      setSubmitted(true);
      toast.success('If an account exists for that email, a reset link has been sent.');
    } catch (err) {
      const msg =
        err?.response?.data?.detail ||
        'Could not process the request. Please try again later.';
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={`${styles.login} d-flex flex-column align-items-center justify-content-center`}>
      <Link to="/login" className="position-absolute top-0 start-0 m-3 btn btn-outline-secondary btn-sm">
        <i className="fa fa-arrow-left me-1"></i> Back to login
      </Link>

      <ToastContainer autoClose={3000} />

      <div className="d-flex align-items-center justify-content-center gap-4 mb-4">
        <div className={`${styles.bgImage1}`}>
          <img src="/assets/MountSinaiLogo.png" alt="logo" className="img-fluid" />
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-4 col-lg-6 mx-auto">
            <div className="row">
              <div className="col text-start">
                <h3 className={`${styles.loginHeading} mb-2`}>Forgot your password?</h3>
                <p className="text-muted mb-4">
                  Enter the email associated with your account and we'll send you a link to reset your password.
                </p>
              </div>
            </div>

            {submitted ? (
              <div className="alert alert-success" role="alert">
                <i className="fa fa-check-circle me-2"></i>
                If an account exists for <strong>{email}</strong>, a reset link has been sent.
                Check your inbox (and spam folder). The link expires in 1 hour.
                <div className="mt-3">
                  <Link to="/login" className="btn btn-outline-secondary btn-sm">
                    Return to login
                  </Link>
                </div>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="was-validated" noValidate>
                <div className="mb-3">
                  <div className="input-group">
                    <span className="input-group-text" id={styles.inputGroupText}>
                      <i className="fa fa-envelope"></i>
                    </span>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="d-grid gap-2">
                  <button type="submit" className="btn btn-danger" disabled={submitting}>
                    <i className="fa fa-paper-plane"></i>{' '}
                    {submitting ? 'Sending...' : 'Send reset link'}
                  </button>
                </div>

                <div className="text-center mt-3">
                  <Link to="/login" className="small">Back to login</Link>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
